package com.wintermar.inspection.feature.presentation.splash

actual suspend fun collectData(onCollect: suspend () -> Unit) {
    // no-op
}
